import type { CustomSectionDto } from '@/src/api/types/generated-types'
import { type FilterableByModule, LocationModule } from '@/src/hooks/location-module/location-module.types'

export const isEnabledByModule = <T extends FilterableByModule>(
  path: T,
  enabledModules: LocationModule[],
  customSection: CustomSectionDto | null
) => {
  return !path.module || enabledModules.includes(path.module) || (path.module === LocationModule.CUSTOM_SECTION && !!customSection?.url)
}

export const isProcurementFreemiumEnabled = <T extends FilterableByModule>(path: T, enabledModules: LocationModule[]) => {
  return path.hideIfEnabled && enabledModules.includes(path.hideIfEnabled)
}

export const filterPathsEnabledByModule = <T extends FilterableByModule>(
  paths: T[],
  enabledModules: LocationModule[],
  customSection: CustomSectionDto | null
) => {
  return paths.filter(p => isEnabledByModule(p, enabledModules, customSection))
}

export const checkIsModuleEnabled = (moduleToCheck: LocationModule, enabledModules?: LocationModule[]) => {
  return !!enabledModules?.includes(moduleToCheck)
}
